import { css } from "styled-components";
import { StyledDropdown } from "../../components/Dropdown/Dropdown";
export var ComboboxMixin = function ComboboxMixin(_ref) {
  var fluidDropdown = _ref.fluidDropdown;

  if (fluidDropdown) {
    return css(["position:relative;", "{width:100%;}"], StyledDropdown);
  }

  return "";
};